import 'luminate/src/main'
import './extensions/toggler'

import ClickBlur from './initializers/click-blur'
import Scroll from './initializers/scroll'
import Image from './initializers/image'
import Autosize from './initializers/autosize'
// import Videobox from './initializers/videobox'
import Promotion from './initializers/promotion'

ClickBlur()
Scroll()
Image()
Autosize()
// Videobox()
Promotion()

import FloatLabel from './modules/float-label'
import Sticky from './modules/sticky'
import ScrollMarker from './modules/scroll-marker'
import Slick from './modules/slick'
import Gallery from './modules/gallery'
import Map from './modules/map'
import Filter from './modules/filter'

Lum.register(FloatLabel)
Lum.register(Sticky)
Lum.register(ScrollMarker)
Lum.register(Slick)
Lum.register(Gallery)
Lum.register(Map)
Lum.register(Filter)



// WEBPACK FOOTER //
// ./public/scripts/src/main.js